export function retryUntil(
  checkFn: () => boolean,
  successFn: () => void,
  failFn: () => void,
  retries = 3,
  interval = 1000,
) {
  let step = 0
  let timer: ReturnType<typeof setTimeout>

  // eslint-disable-next-line consistent-return
  function run() {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    timer && clearTimeout(timer)
    const status = checkFn()

    // check function returns TRUE
    if (status) {
      return successFn()
    }

    // max number of attempts
    // eslint-disable-next-line no-plusplus
    if (++step >= retries) {
      return failFn()
    }

    // check again after {interval} miliseconds
    timer = setTimeout(run, interval)
  }

  run()
}
